import React, { useRef, useState } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import useUploadFile from '../../hooks/useUploadFile';
import useGetImportTemplate from './hooks/useGetImportTemplate';
import {
  ModalBackdrop,
  ModalContent,
  Title,
  Description,
  FileInput,
  FileName,
  Progress,
  ModalButton,
  TemplateLink,
  ErrorMessage,
} from './styles';

const ImportModal = ({ idCard, title, resourceType, description, onClose }) => {
  const [file, setFile] = useState(null);
  const inputFile = useRef(null);
  const { uploadFile, isLoading: isUploadLoading, uploadProgress, uploadSuccess, errorMessage } = useUploadFile();
  const { getTemplate } = useGetImportTemplate();
  console.log(errorMessage);

  const handleUpload = async () => {
    if (!file) {
      toast.error('Please select a file first.');
      return;
    }
    uploadFile(file, resourceType, idCard);
  };

  const onFileSelect = async (event) => {
    if (event.target.files[0]) {
      setFile(event.target.files[0]);
    }
  };

  const onFileSelectClick = () => {
    inputFile.current.click();
  };

  const onCloseClick = () => {
    onClose();
  };

  const onTemplateLinkClick = () => {
    getTemplate(resourceType).then((res) => {
      const file = new Blob([res.data], {
        type: "text/csv",
      });

      const fileURL = URL.createObjectURL(file);

      // Create a temporary <a> tag for downloading
      const a = document.createElement('a');
      a.href = fileURL;
      a.download = resourceType+'ImportTemplate.csv';
      a.target = '_blank';
      a.noopener = true;
      a.noreferrer = true;

      // Trigger the download
      document.body.appendChild(a);
      a.click();

      // Remove the temporary <a> tag and release the URL of the Blob object
      document.body.removeChild(a);
      URL.revokeObjectURL(fileURL);
    });
  };

  return (
    <ModalBackdrop>
      <ModalContent>
        <Title>{title}</Title>
        <Description>{description} Please use this <TemplateLink onClick={onTemplateLinkClick}>template</TemplateLink> to create the CSV file. </Description>
        <ModalButton title={'Select file'} onClick={onFileSelectClick}/>
        {errorMessage && <ErrorMessage>Error: {errorMessage}</ErrorMessage>}
        <FileInput type="file"
                   ref={inputFile}
                   style={{ display: 'none' }}
                   onChange={onFileSelect}
                   accept='.csv'
                   value={undefined} />
        {file ? <>
          <FileName>{file.name}</FileName>
          {uploadProgress >= 100 && <span style={{fontSize:'0.8em'}}> --- {uploadSuccess || 'not '}imported!</span>}
          <Progress progress={uploadProgress} />
        </> : <><br/><br/></>}
        <ModalButton title={'Upload'} onClick={handleUpload} disabled={!file || uploadProgress} />
        <ModalButton title={'Close'} onClick={onCloseClick} style={{ marginLeft: '10px' }} />
      </ModalContent>
      <ToastContainer />
    </ModalBackdrop>
  );
};

export default ImportModal;